export interface Comic {
  id: string;
  title: string;
  author: string;
  coverUrl: string;
  categorySlug: string;
  description: string;
  status: '连载中' | '已完结';
  rating: number;
  totalChapters: number;
  updatedAt: string;
  views: number;
  tags: string[];
  chapters: { number: number; title: string; updatedAt: string }[];
}

export const comics: Comic[] = [
  {
    id: 'duzhe-yu-nanzhu',
    title: '读者与男主的正确合作法',
    author: '金素英',
    coverUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20comic%20cover%20art%20style%2C%20young%20couple%20in%20modern%20setting%2C%20soft%20warm%20lighting%2C%20illustrated%20character%20art%2C%20clean%20composition%2C%20webtoon%20style%20portrait%2C%20simple%20cream%20background%2C%20elegant%20anime%20art&width=800&height=1120&seq=comic-cover-01&orientation=portrait',
    categorySlug: 'lianai-manhua',
    description: '普通读者李素妍意外穿越到了自己最爱的小说世界中，却发现自己竟然成为了女主角。面对冷酷的男主角和错综复杂的剧情，她必须用读者视角找到与男主的正确合作方式，才能回到现实世界。',
    status: '连载中',
    rating: 9.2,
    totalChapters: 78,
    updatedAt: '2026-08-05',
    views: 1250000,
    tags: ['穿越', '恋爱', '浪漫', '甜宠'],
    chapters: [
      { number: 78, title: '第78话 最后的约定', updatedAt: '2026-08-05' },
      { number: 77, title: '第77话 隐藏的真相', updatedAt: '2026-08-04' },
      { number: 76, title: '第76话 心跳加速', updatedAt: '2026-08-03' },
      { number: 75, title: '第75话 突如其来的告白', updatedAt: '2026-08-02' },
      { number: 74, title: '第74话 雨中的相遇', updatedAt: '2026-08-01' },
    ],
  },
  {
    id: 'mowang-de-xinyang',
    title: '魔王的信仰',
    author: '朴志勋',
    coverUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20comic%20cover%2C%20dark%20haired%20male%20protagonist%20with%20magical%20aura%2C%20medieval%20fantasy%20theme%2C%20illustrated%20art%2C%20dramatic%20lighting%2C%20webtoon%20style%2C%20simple%20dark%20background%2C%20epic%20atmosphere&width=800&height=1120&seq=comic-cover-02&orientation=portrait',
    categorySlug: 'qihuan-manhua',
    description: '被封印千年的魔王在新世界中苏醒，却发现世界早已面目全非。为了找回失去的力量和信仰，魔王踏上了一段意想不到的旅程。',
    status: '连载中',
    rating: 9.5,
    totalChapters: 102,
    updatedAt: '2026-08-05',
    views: 2300000,
    tags: ['奇幻', '冒险', '魔法', '战斗'],
    chapters: [
      { number: 102, title: '第102话 觉醒', updatedAt: '2026-08-05' },
      { number: 101, title: '第101话 决战前夕', updatedAt: '2026-08-03' },
      { number: 100, title: '第100话 百年之约', updatedAt: '2026-08-01' },
    ],
  },
  {
    id: 'shaonv-de-mimi',
    title: '少女的秘密',
    author: '李恩珠',
    coverUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20school%20romance%20cover%2C%20beautiful%20schoolgirl%20with%20long%20hair%2C%20cherry%20blossom%20atmosphere%2C%20soft%20pastel%20tones%2C%20webtoon%20illustration%20style%2C%20dreamy%20lighting%2C%20simple%20pinkish%20background&width=800&height=1120&seq=comic-cover-03&orientation=portrait',
    categorySlug: 'xiaoyuan-manhua',
    description: '新学期开始，转学生韩智雅隐藏着一个不能说的秘密。当她与新同学们逐渐熟悉时，这个秘密也逐渐浮出水面，改变了所有人的校园生活。',
    status: '连载中',
    rating: 8.9,
    totalChapters: 56,
    updatedAt: '2026-08-04',
    views: 890000,
    tags: ['校园', '恋爱', '青春', '成长'],
    chapters: [
      { number: 56, title: '第56话 新的开始', updatedAt: '2026-08-04' },
      { number: 55, title: '第55话 告白', updatedAt: '2026-08-02' },
      { number: 54, title: '第54话 误会解除', updatedAt: '2026-07-31' },
    ],
  },
  {
    id: 'ansha-zhe-de-beiju',
    title: '暗杀者的悲剧',
    author: '崔俊赫',
    coverUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20action%20thriller%20cover%2C%20male%20assassin%20in%20dark%20suit%2C%20noir%20atmosphere%2C%20illustrated%20action%20art%2C%20dramatic%20shadows%2C%20webtoon%20style%2C%20minimal%20dark%20background%2C%20intense%20mood&width=800&height=1120&seq=comic-cover-04&orientation=portrait',
    categorySlug: 'dongzuo-manhua',
    description: '顶级暗杀者金哲秀接到了最后一个任务，却发现目标竟然是自己失散多年的亲人。在忠诚与亲情的抉择中，他必须做出艰难的决定。',
    status: '连载中',
    rating: 9.1,
    totalChapters: 64,
    updatedAt: '2026-08-05',
    views: 1560000,
    tags: ['动作', '悬疑', '暗杀', '剧情'],
    chapters: [
      { number: 64, title: '第64话 最后的暗杀', updatedAt: '2026-08-05' },
      { number: 63, title: '第63话 真相大白', updatedAt: '2026-08-03' },
      { number: 62, title: '第62话 潜入行动', updatedAt: '2026-08-01' },
    ],
  },
  {
    id: 'shikong-xuanwo',
    title: '时空漩涡',
    author: '尹瑞妍',
    coverUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20mystery%20fantasy%20cover%2C%20female%20protagonist%20surrounded%20by%20clock%20imagery%2C%20time%20travel%20theme%2C%20illustrated%20art%2C%20mystical%20blue%20tones%2C%20webtoon%20style%2C%20simple%20cosmic%20background&width=800&height=1120&seq=comic-cover-05&orientation=portrait',
    categorySlug: 'xuanyi-manhua',
    description: '物理学家林秀晶在一次实验中意外打开时空漩涡，穿梭于不同的时间线之间。每一次跳跃都带来新的谜团，她必须拼凑零散的线索找出真相。',
    status: '连载中',
    rating: 9.0,
    totalChapters: 45,
    updatedAt: '2026-08-03',
    views: 720000,
    tags: ['悬疑', '科幻', '时间旅行', '推理'],
    chapters: [
      { number: 45, title: '第45话 时空之门的秘密', updatedAt: '2026-08-03' },
      { number: 44, title: '第44话 平行世界', updatedAt: '2026-08-01' },
      { number: 43, title: '第43话 蝴蝶效应', updatedAt: '2026-07-30' },
    ],
  },
  {
    id: 'gaoxiao-riji',
    title: '爆笑职场日记',
    author: '姜泰浩',
    coverUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20comedy%20office%20cover%2C%20funny%20cartoon%20characters%20in%20office%20setting%2C%20humorous%20expression%2C%20bright%20colorful%20illustration%2C%20webtoon%20style%2C%20clean%20white%20background%2C%20playful%20tone&width=800&height=1120&seq=comic-cover-06&orientation=portrait',
    categorySlug: 'gaoxiao-manhua',
    description: '职场菜鸟朴大成的爆笑生存记。从面试被刷到意外入职，每一天都是新的"惊喜"，他的职场生活就是一个行走的笑话！',
    status: '连载中',
    rating: 8.7,
    totalChapters: 120,
    updatedAt: '2026-08-05',
    views: 3100000,
    tags: ['搞笑', '职场', '日常', '喜剧'],
    chapters: [
      { number: 120, title: '第120话 升职？不存在的', updatedAt: '2026-08-05' },
      { number: 119, title: '第119话 团建噩梦', updatedAt: '2026-08-04' },
      { number: 118, title: '第118话 加班夜未眠', updatedAt: '2026-08-03' },
    ],
  },
  {
    id: 'chengshi-lieren',
    title: '城市猎人',
    author: '郑宇镇',
    coverUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20urban%20action%20cover%2C%20male%20protagonist%20in%20city%20night%2C%20modern%20seoul%20cityscape%20background%2C%20illustrated%20action%20art%2C%20dramatic%20neon%20lighting%2C%20webtoon%20style%2C%20cool%20atmosphere&width=800&height=1120&seq=comic-cover-07&orientation=portrait',
    categorySlug: 'dushi-manhua',
    description: '在首尔繁华的都市背后，隐藏着一个神秘的"城市猎人"。他专门惩治那些法律无法制裁的恶人，用自己的方式维护城市正义。',
    status: '已完结',
    rating: 9.3,
    totalChapters: 88,
    updatedAt: '2026-07-15',
    views: 4500000,
    tags: ['都市', '动作', '正义', '犯罪'],
    chapters: [
      { number: 88, title: '第88话 最后的正义（完结）', updatedAt: '2026-07-15' },
      { number: 87, title: '第87话 最终审判', updatedAt: '2026-07-14' },
      { number: 86, title: '第86话 黑暗中的光', updatedAt: '2026-07-13' },
    ],
  },
  {
    id: 'tianshi-zhi-lei',
    title: '天使之泪',
    author: '张美英',
    coverUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20fantasy%20cover%2C%20beautiful%20angel-themed%20female%20character%2C%20soft%20ethereal%20lighting%2C%20feather%20motif%2C%20illustrated%20art%2C%20dreamy%20atmosphere%2C%20webtoon%20style%2C%20minimal%20white%20background&width=800&height=1120&seq=comic-cover-08&orientation=portrait',
    categorySlug: 'lianai-manhua',
    description: '天使因触犯天条被贬下凡间，以人类身份体验人间百态。在人间，她遇到了让她心动的普通人，一段跨界的爱情故事由此展开。',
    status: '已完结',
    rating: 9.4,
    totalChapters: 150,
    updatedAt: '2026-06-20',
    views: 5200000,
    tags: ['恋爱', '奇幻', '天使', '浪漫'],
    chapters: [
      { number: 150, title: '第150话 永远的约定（完结）', updatedAt: '2026-06-20' },
      { number: 149, title: '第149话 天使的抉择', updatedAt: '2026-06-19' },
      { number: 148, title: '第148话 最后的眼泪', updatedAt: '2026-06-18' },
    ],
  },
  {
    id: 'jianshu-dashi',
    title: '剑术大师',
    author: '金胜浩',
    coverUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20martial%20arts%20action%20cover%2C%20male%20swordsman%20with%20flowing%20cape%2C%20dynamic%20fighting%20pose%2C%20illustrated%20fantasy%20art%2C%20dramatic%20wind%20effect%2C%20webtoon%20style%2C%20simple%20warmer%20background&width=800&height=1120&seq=comic-cover-09&orientation=portrait',
    categorySlug: 'dongzuo-manhua',
    description: '曾经的最强剑术大师因背叛而失去一切，重生后他带着前世的记忆重新修炼，誓要夺回属于自己的一切荣耀。',
    status: '连载中',
    rating: 9.0,
    totalChapters: 92,
    updatedAt: '2026-08-04',
    views: 2800000,
    tags: ['动作', '重生', '武侠', '复仇'],
    chapters: [
      { number: 92, title: '第92话 剑圣归来', updatedAt: '2026-08-04' },
      { number: 91, title: '第91话 决战之巅', updatedAt: '2026-08-02' },
      { number: 90, title: '第90话 突破极限', updatedAt: '2026-07-31' },
    ],
  },
  {
    id: 'shejia-kongbuzi',
    title: '社恐的逆袭',
    author: '韩智恩',
    coverUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20school%20comedy%20cover%2C%20shy%20schoolgirl%20transforming%2C%20makeover%20theme%2C%20bright%20illustrated%20art%2C%20uplifting%20mood%2C%20webtoon%20style%2C%20simple%20pastel%20background%2C%20cute%20character%20design&width=800&height=1120&seq=comic-cover-10&orientation=portrait',
    categorySlug: 'xiaoyuan-manhua',
    description: '社恐女孩金多妍在意外获得"自信系统"后，生活发生了翻天覆地的变化。从默默无闻到校园焦点，她的逆袭之路笑料不断。',
    status: '连载中',
    rating: 8.8,
    totalChapters: 68,
    updatedAt: '2026-08-05',
    views: 1750000,
    tags: ['校园', '搞笑', '励志', '系统'],
    chapters: [
      { number: 68, title: '第68话 真正的自信', updatedAt: '2026-08-05' },
      { number: 67, title: '第67话 才艺大赛', updatedAt: '2026-08-03' },
      { number: 66, title: '第66话 新朋友', updatedAt: '2026-08-01' },
    ],
  },
  {
    id: 'heian-shenpan',
    title: '黑暗审判',
    author: '柳承范',
    coverUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20psychological%20thriller%20cover%2C%20mysterious%20figure%20in%20shadow%2C%20dark%20courtroom%20theme%2C%20illustrated%20noir%20art%2C%20tense%20atmosphere%2C%20webtoon%20style%2C%20minimal%20black%20background%2C%20suspenseful&width=800&height=1120&seq=comic-cover-11&orientation=portrait',
    categorySlug: 'xuanyi-manhua',
    description: '一连串神秘的审判事件在城市中引起恐慌。检察官姜贤宇深入调查，发现这些案件背后隐藏着一个惊人的真相，而这个真相与他自己的过去紧密相连。',
    status: '连载中',
    rating: 9.1,
    totalChapters: 38,
    updatedAt: '2026-08-02',
    views: 680000,
    tags: ['悬疑', '犯罪', '推理', '心理'],
    chapters: [
      { number: 38, title: '第38话 审判者的真面目', updatedAt: '2026-08-02' },
      { number: 37, title: '第37话 关键证人', updatedAt: '2026-07-31' },
      { number: 36, title: '第36话 隐藏的证据', updatedAt: '2026-07-29' },
    ],
  },
  {
    id: 'mogui-zongcai',
    title: '魔鬼总裁的小甜妻',
    author: '文彩媛',
    coverUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20office%20romance%20cover%2C%20handsome%20CEO%20and%20cute%20female%20lead%2C%20luxury%20office%20setting%2C%20illustrated%20romantic%20art%2C%20elegant%20style%2C%20webtoon%20design%2C%20simple%20cream%20background&width=800&height=1120&seq=comic-cover-12&orientation=portrait',
    categorySlug: 'dushi-manhua',
    description: '为了偿还家族债务，苏小暖被迫嫁给了商界闻名的"魔鬼总裁"陆景琛。原以为是一场交易，却在相处中发现了对方不为人知的温柔。',
    status: '连载中',
    rating: 9.0,
    totalChapters: 84,
    updatedAt: '2026-08-05',
    views: 3800000,
    tags: ['都市', '恋爱', '总裁', '甜宠'],
    chapters: [
      { number: 84, title: '第84话 真心的告白', updatedAt: '2026-08-05' },
      { number: 83, title: '第83话 危机时刻', updatedAt: '2026-08-04' },
      { number: 82, title: '第82话 家族秘密', updatedAt: '2026-08-03' },
    ],
  },
  {
    id: 'yongzhe-zhuanji',
    title: '勇者传记',
    author: '朴善宇',
    coverUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20adventure%20fantasy%20cover%2C%20young%20hero%20with%20sword%20and%20shield%2C%20epic%20fantasy%20journey%2C%20illustrated%20art%2C%20adventurous%20atmosphere%2C%20webtoon%20style%2C%20simple%20warm%20background%2C%20heroic&width=800&height=1120&seq=comic-cover-13&orientation=portrait',
    categorySlug: 'qihuan-manhua',
    description: '平凡的少年艾伦在村庄被毁后踏上勇者之路，一路上结识了各种伙伴，经历无数冒险，最终成长为真正的勇者。',
    status: '连载中',
    rating: 9.2,
    totalChapters: 110,
    updatedAt: '2026-08-03',
    views: 1950000,
    tags: ['奇幻', '冒险', '成长', '友情'],
    chapters: [
      { number: 110, title: '第110话 勇者试炼', updatedAt: '2026-08-03' },
      { number: 109, title: '第109话 龙之谷', updatedAt: '2026-08-01' },
      { number: 108, title: '第108话 精灵之森', updatedAt: '2026-07-30' },
    ],
  },
  {
    id: 'yewai-canting',
    title: '深夜食堂',
    author: '安秉万',
    coverUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20slice%20of%20life%20food%20cover%2C%20cozy%20restaurant%20night%20scene%2C%20warm%20illustrated%20food%20art%2C%20comforting%20atmosphere%2C%20webtoon%20style%2C%20simple%20dark%20background%2C%20nostalgic%20mood&width=800&height=1120&seq=comic-cover-14&orientation=portrait',
    categorySlug: 'gaoxiao-manhua',
    description: '深夜营业的神秘小餐馆，每个走进来的客人都有自己的故事。老板用一道简单的料理，温暖了无数疲惫的心灵。',
    status: '连载中',
    rating: 9.6,
    totalChapters: 200,
    updatedAt: '2026-08-04',
    views: 6100000,
    tags: ['搞笑', '温情', '美食', '人生'],
    chapters: [
      { number: 200, title: '第200话 特别的一天', updatedAt: '2026-08-04' },
      { number: 199, title: '第199话 老顾客的故事', updatedAt: '2026-08-02' },
      { number: 198, title: '第198话 家的味道', updatedAt: '2026-07-31' },
    ],
  },
  {
    id: 'mojie-zhi-zi',
    title: '魔界之子',
    author: '金载勋',
    coverUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20dark%20fantasy%20cover%2C%20demon%20child%20with%20glowing%20eyes%2C%20supernatural%20theme%2C%20illustrated%20gothic%20art%2C%20mysterious%20dark%20atmosphere%2C%20webtoon%20style%2C%20simple%20dark%20background%2C%20ominous&width=800&height=1120&seq=comic-cover-15&orientation=portrait',
    categorySlug: 'qihuan-manhua',
    description: '人界与魔界的混血儿被两个世界排斥，他必须在夹缝中求生。当两界战争一触即发时，他成为了决定命运的关键。',
    status: '已完结',
    rating: 9.3,
    totalChapters: 95,
    updatedAt: '2026-05-10',
    views: 3400000,
    tags: ['奇幻', '黑暗', '战斗', '成长'],
    chapters: [
      { number: 95, title: '第95话 新世界（完结）', updatedAt: '2026-05-10' },
      { number: 94, title: '第94话 最后一战', updatedAt: '2026-05-09' },
      { number: 93, title: '第93话 两界之门', updatedAt: '2026-05-08' },
    ],
  },
  {
    id: 'chuntian-de-yuehui',
    title: '春天的约定',
    author: '林秀贞',
    coverUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20pure%20romance%20cover%2C%20young%20couple%20under%20cherry%20blossoms%2C%20spring%20atmosphere%2C%20illustrated%20romantic%20art%2C%20soft%20pink%20tones%2C%20webtoon%20style%2C%20simple%20warm%20background&width=800&height=1120&seq=comic-cover-16&orientation=portrait',
    categorySlug: 'lianai-manhua',
    description: '樱花树下的约定，十年的分离后再次相遇。智秀和太勇能否重拾青春的悸动？一段关于初恋、等待与重逢的温暖故事。',
    status: '已完结',
    rating: 9.1,
    totalChapters: 60,
    updatedAt: '2026-04-28',
    views: 2100000,
    tags: ['恋爱', '初恋', '重逢', '治愈'],
    chapters: [
      { number: 60, title: '第60话 樱花盛开时（完结）', updatedAt: '2026-04-28' },
      { number: 59, title: '第59话 十年后的今天', updatedAt: '2026-04-27' },
      { number: 58, title: '第58话 回忆的碎片', updatedAt: '2026-04-26' },
    ],
  },
];

export const getComicById = (id: string) => comics.find((c) => c.id === id);

export const getComicsByCategory = (categorySlug: string) =>
  comics.filter((c) => c.categorySlug === categorySlug);

export const getRelatedComics = (comic: Comic, count: number = 4) =>
  comics.filter((c) => c.id !== comic.id && c.categorySlug === comic.categorySlug).slice(0, count);

export const getLatestUpdates = (count: number = 8) =>
  [...comics].sort((a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime()).slice(0, count);

export const getPopularComics = (count: number = 8) =>
  [...comics].sort((a, b) => b.views - a.views).slice(0, count);

export const getTopRated = (count: number = 8) =>
  [...comics].sort((a, b) => b.rating - a.rating).slice(0, count);